import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { getNumberString } from 'utilities/primitives/convertPrimitiveTypes.js';

export const Temperature = ({
  name,
  is2d,
  inLine,
  temp,
}: {
  name: IconNameV1;
  is2d: boolean;
  inLine: boolean | undefined;
  temp: number | undefined;
}) => {
  const hasTemp = getNumberString(temp);

  if (hasTemp.isNumber) {
    const tempCrowdedClasses = classNames(
      'IconWithText--vCenter IconWithText--tight IconWithText--small',
      { 'u-mB-xs': !is2d },
      { 'u-pR-xs': is2d },
      { 'IconWithText--inline': inLine },
    );

    return (
      <IconWithText icon={name} classes={tempCrowdedClasses}>
        <span className="u-text-sm u-textSemibold">{temp}°</span>
      </IconWithText>
    );
  }

  return null;
};
